module.exports = __webpack_public_path__ + "media/images/flags/AU-f44dbd2b616f2360015f41909038e2df.svg";